module.exports = __webpack_public_path__ + "static/img/4.08d499b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/sp/4.png
// module id = W2QE
// module chunks = 0